import gsap from 'gsap';
import EventDispatcher from './EventDispatcher';
import Global from './Global';
import jQuery from 'jquery';
const $ = jQuery;

export default class SelectFlavour {
  constructor() {
    document
      .querySelector('#selectFlavourNext_btn')
      .addEventListener('click', this.onNext.bind(this));
    document
      .querySelector('#hazelnutSide')
      .addEventListener('click', this.onSelectFlavour.bind(this, 'hazelnut'));
    document
      .querySelector('#chocolateSide')
      .addEventListener('click', this.onSelectFlavour.bind(this, 'chocolate'));
  }

  init() {
    this.isChecked = true;

    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
    // setTimeout(()=>{
    //     this.onOkay();
    // }, 1000)
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showScreen(data.message.data.screenKey);
        break;
    }
  }

  showScreen(screenKey) {
    if (screenKey != 'SelectFlavour') return false;
    Global.selectedFlavour = 'hazelnut';
    this.pageAnimation();
    document.querySelector('#selectFlavour_scr').classList.add('active');
  }

  pageAnimation() {
    gsap.set('#selectFlavourNext_btn', { opacity: 0 });
    gsap.fromTo(
      '#selectFlavour_scr > .appContainer',
      { scale: 0.2, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1, ease: 'power3.out' }
    );

    setTimeout(() => {
      this.events.dispatchEvent({
        type: 'ANIMATION_EVENTS',
        message: {
          event_type: 'twistAnimation',
          data: {
            selector: '#selectFlavour_scr .twistOnIt',
          },
        },
      });

      setTimeout(() => {
        this.events.dispatchEvent({
          type: 'ANIMATION_EVENTS',
          message: {
            event_type: 'buttonAnimation',
            data: {
              selector: '#selectFlavourNext_btn',
            },
          },
        });
      }, 1000);
    }, 500);
  }

  hideControls() {}

  onSelectFlavour(flvour) {
    Global.selectedFlavour = flvour;
    $('#selectFlavourNext_btn').css('opacity', '1');
    $('.tickmark').css('opacity', '0');
    $(`#${flvour}Tick`).css('opacity', '1');
  }

  onNext() {
    // Global.isMultiplayer = false;
    // console.log(Global.isMultiplayer);
    if (Global.selectedFlavour != '') {
      Global.gameTry += 1;
      // Global.clickUpdater('gameTry');
      Global.serverObj.send(
        `${Global.BASE_URL}webservice.php`,
        (response) => {
          const data = JSON.parse(response);

          if (data.code == 200) {
            $('.selectFlavourNext_btn').css('opacity', '0.5');
            this.events.dispatchEvent({
              type: 'LOADER_EVENTS',
              message: {
                event_type: 'switch_page',
                data: {
                  screenKey: Global.isMultiplayer ? 'QRScanner' : 'GameInst',
                },
              },
            });
          } else if (data.code == 400) {
            Global.gameTry -= 1;
          }
        },
        null,
        {
          flavour: Global.selectedFlavour,
          gameTry: Global.gameTry,
          uniqID: Global.U_ID,
          playerMode: Global.isMultiplayer ? 'multiplayer' : 'singleplayer',
          saveType: 'saveFlavour',
        },
        'POST',
        null,
        false
      );
    }
  }

  onOkay() {
    document.querySelector('#score_sec').classList.add('active');
    document.querySelector('#selectFlavour_scr').classList.remove('active');
    setTimeout(() => {
      // document.querySelector(".game_footer").classList.add("active2");
      document.querySelector('.game_timer_sec').classList.add('active');
    }, 100);
    this.events.dispatchEvent({
      type: 'GAME_EVENTS',
      message: {
        event_type: 'level_selected',
        data: {
          level: 1,
        },
      },
    });
  }
}
